// switching from [ import 'react' ] to this removed an existing eslint inference issue https://github.com/jsx-eslint/eslint-plugin-react/issues/2353
import React from 'react'
import { Box, Card, CardActionArea, CardContent, CardMedia, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { Pillar } from '../../../types'
import styles from './PillarCard.module.css'
import { Link } from 'react-router-dom'
import { isUpcomingPillar } from '../../../types/Pillar'
import { getProgrammeRoute } from '../../../types/Programme'

interface PillarCardProps {
    pillar: Pillar,
}

interface CardComponentProps {
    pillar: Pillar,
    isUpcoming: boolean,
}

const PillarCard: React.FC<PillarCardProps> = (props: PillarCardProps) => {
    const { pillar } = props

    const isUpcoming = isUpcomingPillar(pillar)
    const pillarProgrammeRoute = pillar.programme ? getProgrammeRoute(pillar.programme) : undefined

    const linkTo = pillar.route ?? pillarProgrammeRoute ?? `/home`

    return !isUpcoming ? (
        <Grid item mb={3}>
            <Link className={styles.relative} to={linkTo}>
                <CardComponent pillar={pillar} isUpcoming={isUpcoming} />
            </Link>
        </Grid>
    ) : (
        <Grid item mb={3}>
            <Box className={styles.relative} >
                <CardComponent pillar={pillar} isUpcoming={isUpcoming} />
                <ComingSoonBadge />
            </Box>
        </Grid>
    )
}

const CardComponent = (props: CardComponentProps) => {
    const { pillar, isUpcoming } = props

    return (
        <CardActionArea>
            <Card className={clsx(styles.pillarCardBox, { [styles.upcoming]: isUpcoming })} elevation={2}>
                <CardMedia component="img" className={styles.pillarCardMedia} image={pillar.imageURL} />
                <CardContent className={styles.pillarCardContent}>
                    <Typography variant="h6" className={styles.title}>{pillar.title}</Typography>
                    <Typography variant="body2">{pillar.description}</Typography>
                </CardContent>
            </Card>
        </CardActionArea>
    )
}

const ComingSoonBadge = () => {
    const { t } = useTranslation()
    const theme = useTheme()

    const comingSoonBadgeStyle = {
        backgroundColor: theme.palette.primary.dark,
    }

    return (
        <Box className={styles.upcomingBadge} sx={comingSoonBadgeStyle}>
            <Typography variant="overline">{t(`upcoming`)}</Typography>
        </Box >
    )
}

export default PillarCard
export { PillarCardSkeleton } from './PillarCard.skeleton'